import script from "./TenderList.vue?vue&type=script&setup=true&lang=js"
export * from "./TenderList.vue?vue&type=script&setup=true&lang=js"

import "./TenderList.vue?vue&type=style&index=0&id=293a997a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-293a997a"]])

export default __exports__